import { alpha } from "@mui/material";

const styles = (theme) => ({
  tableContainer: {
    width: "100%",
    overflowX: "auto",
    backgroundColor: theme.palette.background.paper,
    borderRadius: "16px",
    height: "100%",
    maxHeight: "100%",
  },
  table: {
    minWidth: 650,
  },
  tableHead: {
    // Optional head background if needed, usually transparent
  },
  tableHeadCell: {
    fontSize: "0.75rem",
    fontWeight: 500,
    py: "6px",
    px: "8px",
    //  color: theme.palette.mode === "dark" ? theme.palette.secondary.light : theme.palette.secondary.dark,
    borderBottom: `1px solid ${theme.palette.secondary.dark}`,
    whiteSpace: "nowrap",
  },
  tableRow: {
    "&:hover": {
      backgroundColor: "inherit",
    },
    // Zebra stripping
    "&.linha-impar": {
      backgroundColor: theme.palette.mode === "dark" ? theme.palette.secondary.dark : theme.palette.secondary.lighter,
    },
    "&.linha-impar:hover": {
      backgroundColor: theme.palette.mode === "dark" ? theme.palette.secondary.dark : theme.palette.secondary.lighter,
    },
    "&.linha-par": {
      backgroundColor: "transparent",
    },
    "&.linha-par:hover": {
      backgroundColor: "transparent",
    },
    minHeight: "28px",
    height: "28px",
  },
  tableCell: {
    fontSize: "0.75rem", // or 0.85rem as Datagrid uses
    py: "2px",
    px: "8px",
    borderBottom: `0.2px solid ${theme.palette.mode === "dark" ? theme.palette.secondary.dark : theme.palette.secondary.lighter}`,
    whiteSpace: "nowrap",
  },
  sortLabel: {
    "&.MuiTableSortLabel-root": {
      color: "inherit",
    },
    "&.MuiTableSortLabel-active": {
      color: theme.palette.mode === "dark" ? alpha(theme.palette.text.main, 0.7) : alpha(theme.palette.text.main, 0.7),
    },
    "& .MuiTableSortLabel-icon": {
      color: `${theme.palette.mode === "dark" ? alpha(theme.palette.text.main, 0.7) : alpha(theme.palette.text.main, 0.7)} !important`,
    },
  },
});

export default styles;
